export default __webpack_public_path__ + "static/media/inicio.f9e9214b.png";